const GREEN_COLOR = '#7fbe0c';
const BLUE_COLOR = '#005880';
const RED_COLOR = '#ee4545';
const LIGHT_BLUE_COLOR = '#2cc3eb';
const YELLOW_COLOR = '#fcc048';
const GRAY_COLOR = '#424d5c';
export const LIGHT_GRAY_COLOR = '#e0e0e0';

export const BRIGHT_GREEN_COLOR = '#7DBE42';
export const LCI_GREEN_COLOR = '#7DBE42';
export const ND_GRAY_LIGHT_2 = '#818B86';
export const ND_BLUE_DARK_2 = '#0A2241';
export const APPROVED_COLOR = '#dae9be';
export const DARK_GRAY_COLOR = '#5F5F63';
export const BACKGROUND_GRAY_COLOR = '#F5F5F5';

export const COLORS = [
  LIGHT_BLUE_COLOR,
  RED_COLOR,
  YELLOW_COLOR,
  GREEN_COLOR,
  '#9e005d',
  '#96a0bd',
  '#bc893f',
  '#6fa8a3',
  '#d9e021',
  LIGHT_GRAY_COLOR,
  GRAY_COLOR,
  BLUE_COLOR,
  '#000000',
] as const;

export const CA_GREEN_COLOR = '#B2DF8A';
export const CA_LIGHT_BLUE_COLOR = '#A6CEE3';
const CA_MEDIUM_BLUE_COLOR = '#1F78B4';
export const CA_DARK_BLUE_COLOR = '#6A3D9A';

export const CA_COLOR_PALLETE = [
  CA_LIGHT_BLUE_COLOR,
  CA_GREEN_COLOR,
  CA_MEDIUM_BLUE_COLOR,
  '#33A02C',
  '#FFA599',
  '#CE4749',
  '#FDBF6F',
  '#FF7F00',
  '#CAB2D6',
  CA_DARK_BLUE_COLOR,
  '#FFFF99',
  '#E6D856',
];

export const LIGHT_TEXT_PRIMARY = '#2D2D2D';
// Legacy color from PDF
export const ndBlueDarkest = '#06264a';
